import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";


interface PromotionLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  Promoted_Role: string;
  Role: string;
  effectiveDate: string;
  duties: string;
}

const PromotionLetter = ({ refNo, date, name, address, Promoted_Role, Role, effectiveDate, duties}: PromotionLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Promotion Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      We are delighted to inform you that in recognition of your hard work, dedication, andvaluable contribution to the company, 
      you are promoted from your current position as <b>{Role}</b> to <b>{Promoted_Role}</b> with effect from <b>{effectiveDate}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
     In this new role, your key responsibilities will include <b>{duties}</b>. A detailed job description is enclosed/attached for your reference.   
    </p>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>We look forward to your continued success in this new role.</p>

    <Signature />
  </div>
);

export default PromotionLetter;
